import React from "react";
import { Typography, TypographyProps } from "@mui/material";
import { useMandatorContext } from "@bn/theming";
import type { MandatorType } from "@bn/theming";

export type MandatorTypographyProps = TypographyProps & {
  [K in MandatorType]?: Partial<TypographyProps>;
};

export const MandatorTypography: React.FC<MandatorTypographyProps> = (
  props
) => {
  const { mandatorSlug, mandatorsList } = useMandatorContext();

  const baseProps = { ...props };
  for (const key of mandatorsList) {
    delete (baseProps as Record<string, unknown>)[key];
  }

  const mandatorOverrides = (props as Record<string, unknown>)[mandatorSlug] as
    | Partial<TypographyProps>
    | undefined;

  const mergedProps: TypographyProps = {
    ...(baseProps as TypographyProps),
    ...(mandatorOverrides ?? {}),
  };

  return <Typography {...mergedProps} />;
};
